/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Update SKU when variant changes
  document.addEventListener('DOMContentLoaded', function() {
    // Listen for variant change events
    document.addEventListener('theme:variant:change', function(event) {
      var variant = event.detail.variant;
      var skuWrapper = document.querySelector('[data-sku-wrapper]');
      var skuElement = document.querySelector('[data-variant-sku]');

      if (skuElement && variant) {
        if (variant.sku && variant.sku !== '') {
          skuElement.textContent = variant.sku;
          if (skuWrapper) {
            skuWrapper.style.display = 'block';
          }
        } else {
          if (skuWrapper) {
            skuWrapper.style.display = 'none';
          }
        }
      }
    });
  });

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


/* ====== Konsens GCLID — captura y atribucion ventas showroom (agregado) ====== */

/*!
 * konsens-gclid.js — Captura de GCLID y reenvío a WhatsApp / Tidio / Calendly
 * Joyería Konsens · Atribución de ventas de showroom a Google Ads
 * ---------------------------------------------------------------------------
 * QUÉ HACE
 *   1. Lee gclid / gbraid / wbraid de la URL del anuncio y los guarda 90 días.
 *   2. Inyecta el id del clic en el mensaje pre-escrito de WhatsApp.
 *   3. Lo guarda como propiedad del contacto en Tidio.
 *   4. Lo agrega como utm_content en los enlaces de Calendly.
 *   Funciona aunque los botones se carguen tarde (usa MutationObserver + reintentos).
 *
 * INSTALACIÓN (Shopify):
 *   Online Store → Themes → Edit code → layout/theme.liquid
 *   Pegar ANTES de </head>:   <script src="{{ 'konsens-gclid.js' | asset_url }}" defer></script>
 *   (subir este archivo en assets/) — o pegar el contenido dentro de <script>…</script>.
 *   Nota: NO usar como "Custom Pixel" de Shopify: ese sandbox no accede al DOM del tema
 *   ni al localStorage del storefront. Debe ir en el tema.
 *
 * CONFIGURACIÓN: editar solo el bloque KONSENS_GCLID_CONFIG de abajo.
 */
(function () {
  'use strict';

  var KONSENS_GCLID_CONFIG = {
    // Número de WhatsApp de respaldo (solo se usa si un botón no trae el suyo).
    // El sitio usa 56987878210 y 56975707795; cada botón conserva el propio.
    whatsappNumber: '56987878210',
    // Mensaje base; el script le agrega " [ref:ID]" al final.
    whatsappMessage: 'Hola Konsens, quiero consultar por una joya.',
    // Selectores donde puede estar el botón/enlace de WhatsApp.
    whatsappSelectors: [
      '#whatsapp-konsens',
      'a[href*="wa.me"]',
      'a[href*="api.whatsapp.com/send"]',
      'a[href*="web.whatsapp.com/send"]'
    ],
    // Selectores de enlaces/embeds de Calendly.
    calendlySelectors: [
      '#calendly-konsens',
      'a[href*="calendly.com"]',
      '[data-url*="calendly.com"]'
    ],
    // Nombre de la propiedad que se guarda en Tidio.
    tidioPropertyName: 'gclid',
    // Días que se conserva el id del clic (= ventana de atribución de Google, máx. 90).
    storageDays: 90,
    // Identificadores de clic a capturar, en orden de prioridad.
    clickIdParams: ['gclid', 'wbraid', 'gbraid'],
    // UTMs que también se conservan y se reenvían a Calendly.
    utmParams: ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'],
    // Prefijo de las claves en localStorage.
    storagePrefix: 'konsens_'
  };

  var CFG = KONSENS_GCLID_CONFIG;
  var DAY_MS = 24 * 60 * 60 * 1000;

  /* ----------------------------- utilidades ----------------------------- */

  function getParam(name) {
    try {
      var m = new RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
      return m && decodeURIComponent(m[1].replace(/\+/g, ' '));
    } catch (e) { return null; }
  }

  function store(key, value) {
    var rec = { value: value, exp: Date.now() + CFG.storageDays * DAY_MS };
    try { localStorage.setItem(CFG.storagePrefix + key, JSON.stringify(rec)); } catch (e) {}
  }

  function read(key) {
    try {
      var rec = JSON.parse(localStorage.getItem(CFG.storagePrefix + key) || '{}');
      return (rec && rec.exp > Date.now() && rec.value) ? rec.value : '';
    } catch (e) { return ''; }
  }

  // Guarda los identificadores de clic y utms presentes en la URL actual.
  function captureFromUrl() {
    CFG.clickIdParams.forEach(function (p) {
      var v = getParam(p);
      if (v) store(p, v);
    });
    CFG.utmParams.forEach(function (p) {
      var v = getParam(p);
      if (v) store(p, v);
    });
  }

  // Devuelve el mejor id de clic disponible (gclid > wbraid > gbraid).
  function getClickId() {
    for (var i = 0; i < CFG.clickIdParams.length; i++) {
      var v = read(CFG.clickIdParams[i]);
      if (v) return v;
    }
    return '';
  }

  function eachMatch(selectors, fn) {
    selectors.forEach(function (sel) {
      var nodes;
      try { nodes = document.querySelectorAll(sel); } catch (e) { return; }
      Array.prototype.forEach.call(nodes, fn);
    });
  }

  // Agrega/actualiza un parámetro en una URL sin duplicarlo.
  function setUrlParam(url, key, value) {
    try {
      var u = new URL(url, window.location.origin);
      u.searchParams.set(key, value);
      return u.toString();
    } catch (e) {
      // Fallback simple si URL() no está disponible o la url es rara.
      var sep = url.indexOf('?') === -1 ? '?' : '&';
      var re = new RegExp('([?&])' + key + '=[^&]*');
      if (re.test(url)) return url.replace(re, '$1' + key + '=' + encodeURIComponent(value));
      return url + sep + key + '=' + encodeURIComponent(value);
    }
  }

  /* ------------------------------- WhatsApp ------------------------------ */

  function wireWhatsApp() {
    var id = getClickId();
    var text = CFG.whatsappMessage + (id ? ' [ref:' + id + ']' : '');
    eachMatch(CFG.whatsappSelectors, function (el) {
      var href = el.getAttribute('href') || '';
      var number = CFG.whatsappNumber;
      // Respeta un número ya presente en el enlace, si lo hubiera.
      var nm = href.match(/(?:wa\.me\/|[?&]phone=)(\d{6,15})/);
      if (nm) number = nm[1];
      var newHref = 'https://wa.me/' + number + '?text=' + encodeURIComponent(text);
      if (el.getAttribute('href') !== newHref) el.setAttribute('href', newHref);
    });
  }

  /* ------------------------------- Calendly ------------------------------ */

  function wireCalendly() {
    var id = getClickId();
    if (!id) return;
    eachMatch(CFG.calendlySelectors, function (el) {
      ['href', 'data-url'].forEach(function (attr) {
        var val = el.getAttribute(attr);
        if (!val || val.indexOf('calendly.com') === -1) return;
        var updated = setUrlParam(val, 'utm_content', id);
        // Reenvía también las utms guardadas, si existen.
        CFG.utmParams.forEach(function (p) {
          if (p === 'utm_content') return;
          var v = read(p);
          if (v) updated = setUrlParam(updated, p, v);
        });
        if (updated !== val) el.setAttribute(attr, updated);
      });
    });
  }

  /* ------------------------------- Tidio --------------------------------- */

  function wireTidio() {
    var id = getClickId();
    if (!id || !window.tidioChatApi) return false;
    var props = {};
    props[CFG.tidioPropertyName] = id;
    try {
      if (typeof window.tidioChatApi.setContactProperties === 'function') {
        window.tidioChatApi.setContactProperties(props);
        return true;
      }
      if (typeof window.tidioChatApi.setVisitorData === 'function') {
        window.tidioChatApi.setVisitorData(props);
        return true;
      }
    } catch (e) {}
    return false;
  }

  /* ------------------------------- init ---------------------------------- */

  function wireAll() {
    wireWhatsApp();
    wireCalendly();
    wireTidio();
  }

  function init() {
    captureFromUrl();
    wireAll();

    // Tidio puede cargar después: engancha su evento de "listo".
    document.addEventListener('tidioChat-ready', wireTidio);

    // Reaplica si el tema inyecta botones de forma dinámica.
    if (window.MutationObserver) {
      var t;
      var obs = new MutationObserver(function () {
        clearTimeout(t);
        t = setTimeout(wireAll, 250);
      });
      try { obs.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    }

    // Reintentos por si Tidio/Calendly/WhatsApp tardan en aparecer.
    var tries = 0;
    var iv = setInterval(function () {
      wireAll();
      if (++tries >= 10) clearInterval(iv); // ~10 s
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expone un getter por si se necesita en otros scripts (formularios, etc.).
  window.getKonsensGclid = getClickId;
})();
